import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { getMitomap } from "../../../../state/selectors/Mitomap.selectors";
import CardWrapper from "../../CardWrapper";
import Card from "../../Card";
import { getPathogenicityColorByAllNames } from "../../../../common/helpers/Constant";

const MitoMapCard = ({ card, mitomap }) => {
  const isDisabled = !mitomap || mitomap?.length < 1;

  const calcMoreDiseases = () => {
    if (mitomap[0]?.diseases?.length > 1) {
      return ` (+${mitomap[0]?.diseases?.length - 1} more)`;
    }
    return null;
  };

  const calcColor = () => {
    let color = getPathogenicityColorByAllNames("VUS");
    if (mitomap && mitomap[0]?.diseases?.length > 0) {
      const status = mitomap[0].disease_status;
      // Check for explicit classifications, order is important as P* matches LP* too.
      if (status.includes("LP*")) {
        color = getPathogenicityColorByAllNames("Likely Pathogenic");
      } else if (status.includes("P*")) {
        color = getPathogenicityColorByAllNames("Pathogenic");
      } else if (status.includes("VUS")) {
        color = getPathogenicityColorByAllNames("VUS");
      } else if (status.includes("B*")) {
        color = getPathogenicityColorByAllNames("Benign");
      }

      // Check the first word of the status:
      else if (status.startsWith("Cfrm")) {
        color = getPathogenicityColorByAllNames("Pathogenic");
      } else if (status.startsWith("Reported")) {
        color = getPathogenicityColorByAllNames("Likely Pathogenic");
      } else if (status.startsWith("Unclear")) {
        color = getPathogenicityColorByAllNames("VUS");
      } else if (status.startsWith("Conflicting")) {
        color = getPathogenicityColorByAllNames("VUS");
      }
    }
    return color;
  };

  const calcPathogenicity = () => {
    if (mitomap && mitomap[0]?.disease_status) {
      return (
        <b data-testid="status" style={{ color: calcColor() }}>
          {mitomap[0].disease_status}
        </b>
      );
    }
    return null;
  };

  const calcFrequency = () => {
    const frequency = parseFloat(mitomap[0].main_data.substring(4));
    let { color } = card;
    if (frequency === 0) {
      color = getPathogenicityColorByAllNames("Likely Pathogenic");
    } else if (frequency < 0.01) {
      color = getPathogenicityColorByAllNames("Uncertain Significance");
    } else if (frequency >= 0.01 && frequency < 0.05) {
      color = getPathogenicityColorByAllNames("Likely Benign");
    } else if (frequency >= 0.05) {
      color = getPathogenicityColorByAllNames("Benign");
    }
    return <div style={{ color }}> {mitomap[0].main_data}</div>;
  };

  return (
    <CardWrapper
      {...card}
      isDisabled={isDisabled}
      color={calcColor()}
      secondaryTitle={calcPathogenicity()}
    >
      {mitomap &&
      Array.isArray(mitomap[0]?.diseases) &&
      mitomap[0]?.diseases[0] &&
      mitomap[0]?.diseases[0].length > 0 ? (
        <div data-testid="diseases">
          Diseases: <b>{mitomap[0].diseases[0]}</b> {calcMoreDiseases()}
        </div>
      ) : null}
      {mitomap && mitomap[0]?.main_data ? (
        <div data-testid="frequency">
          <b>{calcFrequency()}</b>
        </div>
      ) : null}
    </CardWrapper>
  );
};

MitoMapCard.propTypes = {
  mitomap: PropTypes.arrayOf(
    PropTypes.shape({
      version: PropTypes.string,
      ac: PropTypes.number,
      af: PropTypes.number,
      disease_status: PropTypes.string,
      diseases: PropTypes.arrayOf(PropTypes.string),
      heteroplasmy: PropTypes.string,
      homoplasmy: PropTypes.string,
      pub_med_references: PropTypes.arrayOf(PropTypes.number),
      main_data: PropTypes.string,
    })
  ),
  card: PropTypes.instanceOf(Card).isRequired,
};

MitoMapCard.defaultProps = {
  mitomap: [],
};

const mapStateToProps = (state) => ({
  mitomap: getMitomap(state),
});

export default connect(mapStateToProps)(MitoMapCard);
